<template>
  <div class="dashboard-panel p-loans-funded">
    <div>
      <div class="panel-header">
        <h2>Loans Funded</h2>
      </div>

      <div class="panel-content">
        <Graph
          v-if="!loading && matches.length"
          id="chart-loans-funded"
          :chartData="graphData"
          :options="graphOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Graph from './Graph'

export default {
  name: 'PanelLoansFunded',
  components: {
    Graph,
  },
  props: {
    matches: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loading: true,
    graphData: {},
    graphOptions: {
      animation: {},
      layout: {
        padding: {
          top: 20,
          bottom: 40,
          left: 20,
          right: 20,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false,
            tickMarkLength: 0,
            zeroLineWidth: 0,
          },
          ticks: {
            padding: 15,
            display: true,
          },
        }],
        yAxes: [{
          gridLines: {
            drawOnChartArea: false,
            tickMarkLength: 0,
            zeroLineWidth: 0,
          },
          ticks: {
            display: false,
          },
        }],
      },
      tooltips: {
        enabled: false,
      },
    },
  }),

  watch: {
    matches: {
      handler () { this.buildGraphData() },
      deep: true,
    },
  },

  mounted () {
    this.buildGraphData()
  },

  methods: {
    buildGraphData () {
      this.loading = true

      let potentialFunded = 0
      let totalFunded = 0

      this.matches.forEach(({ status, deal }) => {
        if (status === 'Funded') {
          totalFunded += Number(deal.dealSize)
        } else {
          potentialFunded += Number(deal.dealSize)
        }
      })

      this.graphOptions.scales.yAxes[0].ticks.max = Math.max(
        potentialFunded, totalFunded,
      ) + 10

      this.graphData = {
        labels: ['Potential Funding', 'Total Funded'],
        datasets: [{
          data: [potentialFunded, totalFunded],
          backgroundColor: ['#194253', '#0096A6'],
          minBarLength: 10,
        }],
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-header {
  padding: 0 15px;
}
</style>
